var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{on:{"click":_vm.logoutUser}},[_vm._v(_vm._s(_vm.$t('login.logout')))])}
var staticRenderFns = []

export { render, staticRenderFns }